import PropTypes from "prop-types";
import React from "react";

import { Image, StyleSheet } from "react-native";
import { connect } from "react-redux";

const AVATARS = {
  f: [
    require("../assets/avatars/woman/1.png"),
    require("../assets/avatars/woman/2.png"),
    require("../assets/avatars/woman/3.png"),
    require("../assets/avatars/woman/4.png"),
    require("../assets/avatars/woman/5.png"),
    require("../assets/avatars/woman/6.png"),
    require("../assets/avatars/woman/7.png"),
    require("../assets/avatars/woman/8.png"),
    require("../assets/avatars/woman/9.png"),
    require("../assets/avatars/woman/10.png"),
    require("../assets/avatars/woman/11.png"),
    require("../assets/avatars/woman/12.png"),
    require("../assets/avatars/woman/13.png"),
    require("../assets/avatars/woman/14.png"),
    require("../assets/avatars/woman/15.png"),
    require("../assets/avatars/woman/16.png"),
    require("../assets/avatars/woman/17.png"),
    require("../assets/avatars/woman/18.png"),
    require("../assets/avatars/woman/19.png"),
    require("../assets/avatars/woman/20.png"),
    require("../assets/avatars/woman/21.png"),
    require("../assets/avatars/woman/22.png")
  ],
  m: [
    require("../assets/avatars/man/1.png"),
    require("../assets/avatars/man/2.png"),
    require("../assets/avatars/man/3.png"),
    require("../assets/avatars/man/4.png"),
    require("../assets/avatars/man/5.png"),
    require("../assets/avatars/man/6.png"),
    require("../assets/avatars/man/7.png"),
    require("../assets/avatars/man/8.png"),
    require("../assets/avatars/man/9.png"),
    require("../assets/avatars/man/10.png"),
    require("../assets/avatars/man/11.png"),
    require("../assets/avatars/man/12.png"),
    require("../assets/avatars/man/13.png"),
    require("../assets/avatars/man/14.png"),
    require("../assets/avatars/man/15.png"),
    require("../assets/avatars/man/16.png"),
    require("../assets/avatars/man/17.png"),
    require("../assets/avatars/man/18.png")
  ]
};

class PatientAvatar extends React.Component {
  static propTypes = {
    cardNumber: PropTypes.string.isRequired,
    gender: PropTypes.oneOf(["f", "m"]).isRequired
  };

  render() {
    const { cardNumber, gender, themeColors } = this.props;

    const seed = cardNumber
      .split("")
      .reduce(
        (currentSeed, c) =>
          (currentSeed + c.charCodeAt(0)) % AVATARS[gender].length,
        0
      );

    return (
      <Image
        source={AVATARS[gender][seed]}
        style={[
          styles.avatar,
          {
            backgroundColor: themeColors.lightestPrimary
          }
        ]}
      />
    );
  }
}

const styles = StyleSheet.create({
  avatar: {
    borderRadius: 30,
    height: 60,
    width: 60
  }
});

export default connect(state => ({
  themeColors: state.themeColors
}))(PatientAvatar);
